export class SurveyList {
}
//# sourceMappingURL=survey-list.js.map